import { render, staticRenderFns } from "./tcgm-record.vue?vue&type=template&id=1eb0b584&"
import script from "./tcgm-record.vue?vue&type=script&lang=js&"
export * from "./tcgm-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports